<template>
  <div class="detialBox mt-h">
    <div class="detial container" id="container">
      <div class="pagenav py-1">
        <span class="go_home" @click="goHomeFn">Home</span> >
        {{ detailsInfo.postTitle }}
      </div>
      <!-- banner -->
      <div class="detial-banner" v-show="detailsInfo">
        <img
          v-if="detailsInfo.type == '图片'"
          :src="detailsInfo.imageUrl"
          alt
          width="100%"
        />
        <!-- <video v-if="detailsInfo.type =='视频'" :src="detailsInfo.sourceUrl" width="100%" controls></video> -->
        <div
          v-show="detailsInfo.type == '视频' || detailsInfo.type == '直播'"
          id="player_box"
          ref="play_box"
        ></div>
      </div>

      <!-- iconGroup -->
      <!-- <DetialIcon v-if="detailsInfo" :detailData="detailsInfo" @showWxFn='isShowWx = true' @showDialogFn='hbDialog = true'></DetialIcon> -->

      <DetialIcon
        v-if="detailsInfo"
        :detailData="detailsInfo"
        @showWxFn="isShowWx = true"
        @showDialogFn="showDialogFn"
      ></DetialIcon>

      <!-- 文章区域 -->
      <Artical :detailData="detailsInfo"></Artical>

      <!-- <div class="p-1">
        <img src="@/assets/imgs/detial/item.png" alt width="100%" />
      </div>-->
      <!-- <div class="addthis_inline_share_toolbox"></div> -->
      <!-- <div class="at-image-sharing-tool-btns at-custom-shape"></div> -->

      <div class="related">
        <div class="article-btn">RELATED ARTICLES</div>
      </div>
      <!--  article-list -->
      <ArticleList
        v-if="artilcleList"
        :artilcleList="artilcleList"
      ></ArticleList>

      <!-- loadmore -->
      <div class="w-100 morebox py-2">
        <div class="loadmore" @click="loadMoreFn">
          <span class="loadmore-txt pr-1">Load more</span>
          <b-icon icon="chevron-down"></b-icon>
        </div>
        <BackTop class="phoneback"></BackTop>
      </div>
    </div>
    <Footer></Footer>
    <div
      class="model_box"
      :class="{ post_model: showModel }"
      v-if="isShowModel && artilcleList.length > 0"
    >
      <div class="top_title">
        <i class="el-icon-close" @click="isShowModel = false"></i>
        <span class="tit_txt">MORE STORIES</span>
      </div>
      <div class="img_box" @click="gotoDetail(artilcleList[0]['postId'])">
        <img :src="setImgFn(artilcleList[0]['sourceUrl'])" alt="" />
      </div>
      <div class="dec_txt" @click="gotoDetail(artilcleList[0]['postId'])">
        {{ artilcleList[0]["postTitle"] }}
      </div>
    </div>
    <div class="imgDialog" v-if="hbDialog">
      <div class="img_box">
        <img
          class="close_img"
          @click="close_model"
          src="@/assets/imgs/detial/close_icon.png"
          alt=""
        />
        <img class="hb_img" :src="postImg" alt="" />
      </div>
    </div>
    <div class="weixin_box" v-if="isShowWx" @click="isShowWx = false">
      <img class="hint_img" src="@/assets/imgs/weShare.jpg" alt="" />
    </div>
    <div id="fb-root"></div>
    <Share
      v-if="this.$store.state.showShareModel"
      :detailData="detailsInfo"
      @showWxFn="isShowWx = true"
      @showDialogFn="showDialogFn"
    ></Share>
  </div>
</template>

<script>
import DetialIcon from "./detialchild/DetialIconGroup.vue";
import Artical from "./detialchild/Artical.vue";
import ArticleList from "./detialchild/ArticleList.vue";

import Share from "@/components/common/model/share.vue";
import Footer from "@/components/common/layout/Footer.vue";
import BackTop from "@/components/common/return/return.vue";
import {
  getDetails,
  getPreview,
  getMoreData,
  getPosterImg,
  getPlayurl,
  setlike,
  getPreviewPoster,
} from "@/network/details.js";
import { setTimeout } from "timers";
import VideoTrack from "@/utils/track/content/video.js";

export default {
  name: "Detial",
  components: {
    DetialIcon,
    Artical,
    ArticleList,
    Footer,
    BackTop,
    Share,
  },
  data() {
    return {
      postId: "",
      detailsInfo: "",
      artilcleList: [],
      indexNub: 3,
      viewData: [],
      realArr: "",
      aaa: "",
      showModel: false,
      page: 1,
      isShowModel: true,
      postImg: "",
      hbDialog: false,
      isShowWx: false,
      source: {},
      isLive: false,
      playerHeight: 400,
      coverImg: "",
      showShareModel: false,
      previewPostId: "", //预览的标志
      // start 埋点所需
      videoTrack: null,
      // end 埋点所需
    };
  },
  created() {
    this.getSendData();
    // this.initFB();
  },
  computed: {
    setImgFn() {
      return function(url) {
        if (url) {
          let index = url.lastIndexOf(".");
          let tempUrl = url.slice(0, index) + "_related" + url.slice(index);
          return tempUrl;
        }
      };
    },
    // start 埋点所需数据
    trackData() {
      return {
        content_id: this.detailsInfo.postId,
        content_name: this.detailsInfo.postTitle,
        content_form: "text",
        live_status: 4,
        file_type: 1,
        publish_time: this.detailsInfo.postDate,
        current_page: "内容详情页面",
        utm_source: "本站跳转",
      };
    },
    // end 埋点所需数据
  },
  mounted() {
    // start 埋点所需
    this.videoTrack = new VideoTrack();
    // end 埋点所需

    this.postId = this.$route.query.postId;

    this.getDetailFn();
    window.addEventListener("scroll", this.handleScroll);
    this.getArticel();
    this.getPosterImgFn();
    this.setPlayerheight();
    // alert(meta_title)
    // console.log(this.$store.state.metaInfo);
    var meta = document.getElementsByTagName("meta");
    // console.log(meta)
    // var detWidth = document.getElementsByClassName("player_box")[0];
    // console.log(detWidth.clientHeight, "clientHeight ");
    // this.$nextTick(()=>{

    // })
    // this.initAly()
    // this.handleViewData();
    // this.getPreviewData();         // 有问题打开
    // this.initFB();
    // this.setMate();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    showshare(e) {
      console.log(123123);
    },
    //  关闭海报允许页面滚动
    close_model() {
      this.hbDialog = false;
      var s_body = document.querySelector("body");
      s_body.style.overflowY = "auto";
    },
    showDialogFn() {
      //  出现海报弹窗禁止Y轴滚动，（小屏幕有样式问题）
      this.hbDialog = true;
      var s_body = document.querySelector("body");

      if (this.hbDialog) {
        s_body.style.overflowY = "hidden";
      } else {
        s_body.style.overflowY = "auto";
      }
    },

    // 动态计算阿里云播放器的高度
    setPlayerheight() {
      var container = document.getElementById("container");
      if (container.clientWidth > 750) {
        this.playerHeight = (container.clientWidth - 30) / (16 / 9) + "px";
        console.log(this.playerHeight, "playerHeight111");
      } else {
        this.playerHeight = container.clientWidth / (16 / 9) + "px";
        // console.log(this.playerHeight, "playerHeight222");
      }
      // console.log(alHeight.clientWidth-30, "12222222");
    },
    goHomeFn() {
      this.$router.push("/home").catch((err) => {
        err;
      });
    },
    getPlayurlFn(vid, type) {
      // console.log(vid,"ssss")
      getPlayurl({ videoId: vid }).then((res) => {
        if (res.code == 200) {
          this.source = JSON.stringify(res.data.source);
          this.initAly();
        } else {
          console.log(this.detailsInfo.sourceUrl, "aaaaa");
          this.source = this.$store.state.baseUrl + this.detailsInfo.sourceUrl;
          this.initAly();
        }
      });
    },
    initAly() {
      // 封面图
      this.coverImg = this.$store.state.baseUrl + this.detailsInfo.imageUrl;
      var _this = this;
      var alplayer = new Aliplayer(
        {
          id: "player_box",
          source: this.source,
          // playauth : '',
          cover: this.coverImg, //播放器封面图
          width: "100%",
          // height: "300px",
          height: this.playerHeight,
          autoplay: true,
          isLive: this.isLive,
          rePlay: true,
          playsinline: true,
          preload: true,
          controlBarVisibility: "hover",
          useH5Prism: true,
          defaultDefinition: "SD",
          skinLayout: [
            {
              name: "bigPlayButton",
              align: "cc",
            },
            {
              name: "H5Loading",
              align: "cc",
            },
            {
              name: "errorDisplay",
              align: "tlabs",
              x: 0,
              y: 0,
            },
            {
              name: "infoDisplay",
            },
            {
              name: "tooltip",
              align: "blabs",
              x: 0,
              y: 56,
            },
            {
              name: "thumbnail",
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                {
                  name: "progress",
                  align: "blabs",
                  x: 0,
                  y: 44,
                },
                {
                  name: "playButton",
                  align: "tl",
                  x: 15,
                  y: 12,
                },
                {
                  name: "timeDisplay",
                  align: "tl",
                  x: 10,
                  y: 7,
                },
                {
                  name: "fullScreenButton",
                  align: "tr",
                  x: 10,
                  y: 12,
                },
                {
                  name: "setting",
                  align: "tr",
                  x: 10,
                  y: 12,
                },
                {
                  name: "volume",
                  align: "tr",
                  x: 10,
                  y: 10,
                },
              ],
            },
          ],
        },
        function(player) {
          // console.log("~The player is created");
          // _this.setPlayerheight();
          _this.videoTrack.add({
            value: _this.trackData,
            dom: _this.$refs.play_box.querySelector("video"),
          });
          // _this.videoTrack.init();
        }
      );
    },
    getPosterImgFn() {
      //  正常文章
      if (this.postId) {
        getPosterImg({ postId: this.postId }).then((res) => {
          this.postImg = res.data;
        });
      }
    },
    gotoDetail(id) {
      this.$router.push({
        path: "/detail",
        query: {
          postId: id,
        },
      });
    },
    handleScroll() {
      if (document.documentElement.scrollTop > 100) {
        this.showModel = true;
      } else {
        this.showModel = false;
      }
      // console.log(document.documentElement.scrollTop);
    },
    getPreviewData() {
      var review_id = localStorage.getItem("review_id");
      if (review_id) {
        getPreview({ previewPostId: review_id }).then((res) => {
          if (res.code == 200) {
            this.$nextTick(() => {
              this.detailsInfo = res.data;
              if (res.data.type == "视频") {
                if (
                  this.detailsInfo.sourceUrl != null &&
                  this.detailsInfo.sourceUrl
                ) {
                  if (this.detailsInfo.sourceUrl.indexOf("http") > -1) {
                    // console.log(1)
                    this.source =
                      this.$store.state.baseUrl + this.detailsInfo.sourceUrl;
                    this.initAly();
                  } else {
                    this.getPlayurlFn(this.detailsInfo.sourceUrl);
                  }
                }
              }
              if (this.detailsInfo.type == "直播") {
                this.isLive = true;
                this.source = this.detailsInfo.sourceUrl;
                this.initAly();
              }
            });
          }
          // console.log(this.detailsInfo, "detailsInfo");
        });
      }
      // console.log(review_id);
    },
    getSendData() {
      let self = this;
      this.$nextTick(() => {
        window.addEventListener(
          "message",
          function(event) {
            if (event.data.previewPostId) {
              this.realArr = event.data.previewPostId;
              let idx = {};
              idx.previewPostId = this.realArr;
              localStorage.setItem("review_id", this.realArr);
              self.getPreviewData();
              // 获取预览海报路径
              getPreviewPoster({
                previewPostId: event.data.previewPostId,
              }).then((res) => {
                self.postImg = res.data;
                console.log(res.data, "res.data");
                console.log(self.postImg, "self.postImg");
              });
            }
          },
          false
        );
      });
    },
    loadMoreFn() {
      this.page++;
      this.getArticel();
      // this.indexNub = this.indexNub + 3;
    },
    getArticel() {
      // console.log("", "resresrser");

      getMoreData({ page: this.page, size: 3, postId: this.postId }).then(
        (res) => {
          // console.log(res, "resresrser");
          this.artilcleList = this.artilcleList.concat(res.data);
        }
      );
    },
    getDetailFn() {
      getDetails({ postId: this.postId }).then((res) => {
        if (res.code == 0) {
          this.detailsInfo = res.data.wpIndex;
          document.title = res.data.wpIndex.postTitle + " | ShanghaiEye";
          document.querySelector('meta[property="og:title"]').content =
            res.data.wpIndex.postTitle + " | ShanghaiEye";
          document.querySelector('meta[property="og:description"]').content =
            res.data.wpIndex.postTitle + " | ShanghaiEye";
          document.querySelector('meta[property="og:image"]').content =
            "https://www.shanghaieye.cn" + res.data.wpIndex.imageUrl;
          if (
            this.detailsInfo.sourceUrl != null &&
            this.detailsInfo.sourceUrl &&
            this.detailsInfo.type == "视频"
          ) {
            if (this.detailsInfo.sourceUrl.indexOf("http") > -1) {
              // console.log(this.detailsInfo.sourceUrl, "11111");
              this.source = this.detailsInfo.sourceUrl;
              this.initAly();
            } else {
              // console.log(this.detailsInfo.sourceUrl,'2222')

              // 视频需要拼接域名或者ip地址，传参数判断。
              let type = "video";
              this.getPlayurlFn(this.detailsInfo.sourceUrl, type);
            }
          }
          if (this.detailsInfo.type == "直播") {
            this.isLive = true;
            this.source = this.detailsInfo.sourceUrl;
            // console.log(this.source,"bbbbbb");
            this.initAly();
          }
          // this.artilcleList = res.data.articles;
        }
      });
    },
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="less">
.detialBox {
  .prism-player .prism-big-play-btn {
    position: absolute;
    left: 50% !important;
    top: 50% !important;
    display: block;
    transform: translate(-50%, -50%);
  }
  .prism-player .prism-ErrorMessage .prism-error-operation a {
    font-size: 16px;
  }
  img {
    // width: 100%;
    height: auto;
  }
  .pcback,
  .phoneback {
    display: none;
  }
  .pagenav {
    color: #c3c3c3;
    font-size: 16px;
    font-family: Open Sans;
    .go_home {
      cursor: pointer;
      &:hover {
        color: #666;
      }
    }
  }
  .detial {
    .related {
      // margin-bottom: 10px;
      height: 0.9rem;
      font-size: 14px;
      // font-family: Calibri;
      // width: calc(100% - 0.5rem);
      margin-bottom: 10px;
      border-bottom: 2px solid #53a1dc;
      .article-btn {
        font-weight: bold;
        background: #53a1dc;
        height: 0.9rem;
        line-height: 0.9rem;
        width: 4rem;
        text-align: center;
        color: #ffffff;
      }
    }
    .morebox {
      clear: both;
      width: 100%;
    }
    .loadmore {
      // border-radius: 5px;
      font-size: 12px;
      color: #929292;
      font-family: Open Sans;
      // font-weight: bold;
      cursor: pointer;
      line-height: 0.3rem;
      // margin: 0.4rem auto;
      display: block;
      margin: 0 auto;
      width: 3rem;
      line-height: 0.7rem;
      text-align: center;
      border: 1px solid #ccc;
      padding: 0.1rem 0.1rem 0.1rem 0.2rem;
      text-align: center;
    }
  }
  .model_box {
    position: fixed;
    right: -345px;
    bottom: 120px;
    border: 1px solid #ededed;
    width: 340px;
    background-color: #fff;
    padding: 20px;
    z-index: 100;
    transition: all 0.5s cubic-bezier(0.265, 0.365, 0.26, 0.865);
    &.post_model {
      right: 0;
    }
    .top_title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      i {
        font-size: 18px;
        padding: 0 8px;
        font-weight: bold;
        cursor: pointer;
      }
      .tit_txt {
        flex: 1;
        font-family: "Open Sans", arial, sans-serif;
        color: #222;
        font-size: 17px;
        font-weight: 600;
        line-height: 30px;
        display: inline-block;
        text-align: center;
      }
    }
    .img_box {
      width: 100%;
      height: 167px;
      margin-bottom: 10px;
      cursor: pointer;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .dec_txt {
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;
      &:hover {
        color: #4db2ec;
      }
    }
  }
  .imgDialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #eaeaea;
    z-index: 6666;
    // display: flex;
    // align-content: center;
    // justify-content: center;
    .img_box {
      width: 90%;
      height: 100%;
      margin: 0 auto;
      position: relative;
      .close_img {
        width: 36px;
        height: 36px;
        position: absolute;
        right: -14px;
        top: -16px;
        z-index: 6666;
      }
      .hb_img {
        width: 100%;
        display: block;
        margin-top: 22px;
      }
    }
  }
  .weixin_box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 6666;
    .hint_img {
      // width: 100%;
      // max-width:400px;
      height: 100vh;
      margin: 0 auto;
      display: block;
    }
  }
}

@media screen and (min-width: 768px) {
  .detialBox {
    .imgDialog {
      display: none;
    }
    #player_box {
      // height: 400px !important;
    }
    .pcback {
      display: block;
    }
    .loadmore {
      border-radius: 1px;
      font-size: 12px;
      color: #929292;
      font-family: FranklinGothic-Demi;
      // font-weight: bold;
      cursor: pointer;
      line-height: 0.2rem !important;
      // margin: 0.4rem auto;
      display: block;
      margin: 0 auto;
      text-align: center;
      border: 1px solid #ccc;
      width: 1.6rem !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .detialBox {
    .model_box {
      display: none;
    }
    .container {
      margin: 0 auto !important;
    }
    #player_box {
      width: 100%;
      // height: 300px;
    }
    .morebox {
      position: relative;
    }
    .phoneback {
      position: absolute;
      display: block;
      transform: translate(0, 50%);
    }
    .container {
      width: 100% !important;
      padding: 0;
      margin: 0;
      // margin-top: 1.3rem;
    }
    .pagenav {
      display: none;
      padding-top: 0;
    }
    .related {
      margin-bottom: 10px !important;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }
}
</style>
